import { HelmetDexteel } from "@dexteel/mesf-core";
import { ShelvesProvider } from "./context/ShelvesContext";
import { ConfigurationShelvesPage } from "./ShelvesPage";

const ShelvesPage = () => {
  return (
    <>
      <HelmetDexteel title="Shelves Configuration" />
      <ShelvesProvider>
        <ConfigurationShelvesPage />
      </ShelvesProvider>
    </>
  );
};

export default ShelvesPage;
